import React from 'react'
import { useSelector } from 'react-redux'
import assignmentSelectors from '../../../../store/selectors/assignment.selectors'
import { LANGUAGES } from '../../../../constants/languages'
import { Spin } from 'antd'
import ClustersSection from '../clusters/ClustersSection'
import TextHomeSection from '../text-home/TextHomeSection'
import usePageTransition from '../../../../hooks/usePageTransition'

/**
 * HomeSection component
 * 
 * Renders either the TextHomeSection or ClustersSection based on the language type.
 * Uses deferred rendering to improve UI responsiveness during navigation.
 */
const HomeSection = () => {
    const language = useSelector(assignmentSelectors.language)
    const isFetchingAssignment = useSelector(assignmentSelectors.isFetching)
    const isTransitioning = usePageTransition()

    // Determine which content to render based on language
    const getContentFromLanguage = language => {
        switch (language) {
            case LANGUAGES.NEW_TEXT.value:
                return <TextHomeSection />
            default:
                return <ClustersSection />
        }
    }

    // Render the appropriate section content after transition
    const renderSectionContent = () => (
        <div>{language && getContentFromLanguage(language)}</div>
    )

    return (
        <Spin spinning={isFetchingAssignment} tip='Loading assignment...' style={{ height: '50vh' }}>
            {isTransitioning ? <Spin className='mt-64'/> : renderSectionContent()}
        </Spin>
    )
}

export default HomeSection
